import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { CENTERED_STYLE } from '../constants/styles';

export const Loader = () => {
  return (
    <Box sx={CENTERED_STYLE}>
      <CircularProgress color="primary" size={60} />
    </Box>
  );
};
